/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AccountVisibility.scss';

import React from 'react';
import { connect } from 'react-redux';
import Store from 'state/Store';

import { FormattedDate } from 'components/shared/Text/Text';
import { hideShowAll } from 'state/preferences/PreferencesActions';
import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';
import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import AccountVisibilityTable from './AccountVisibilityTable';
import { NON_BREAKING_SPACE } from 'services/Formats';
import Content from 'services/Content';
import { getAsOfDate } from 'state/account/AccountSelectors';

const showAll = () => {
  Store.dispatch(hideShowAll(true));
};

const AccountVisibility = ({ asOfDate, is529Only }) => {
  const formattedDate = <FormattedDate>{asOfDate}</FormattedDate>;

  return (
    <div className="account-visibility-main">
      <PreferencesSection fullBackground={true}>
        <div className="account-visibility-section-headers">
          <PreferencesRow>
            <PreferencesCol col={9}>
              <div className="account-visibility-section-header-label">
                Account Visibility
                <span className="account-visibility-as-of-date">
                  Balances as of {formattedDate}
                  {NON_BREAKING_SPACE}
                  <DisclosureModal
                    content={
                      is529Only
                        ? Content.asOfDateDisclosure529Only
                        : Content.asOfDateDisclosure
                    }
                    title="Important Information Regarding the Updating of Account Balances"
                    hideLinkContent
                  />
                </span>
              </div>
              <div className="customize-accounts-section-sub-header">
                Accounts will be hidden from the Dashboard, Accounts and
                Transaction flows.
              </div>
            </PreferencesCol>
            <PreferencesCol col={3}>
              <div className="account-visibility-sub-header-links">
                <button className="hide-show-buttons" onClick={showAll}>
                  Show All
                </button>
              </div>
            </PreferencesCol>
          </PreferencesRow>
        </div>
        <div className="account-visibility-section-body">
          <PreferencesRow>
            <PreferencesCol col={12}>
              <AccountVisibilityTable />
            </PreferencesCol>
          </PreferencesRow>
        </div>
      </PreferencesSection>
    </div>
  );
};

const mapStateToProps = (state) => ({
  asOfDate: getAsOfDate(state),
  is529Only: state.view.hasCollegeSavingsOnly
});

export default connect(mapStateToProps)(AccountVisibility);
